// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__fmk4w","full":"Container_full__phEBX","xlWide":"Container_xlWide__y-KMN","wide":"Container_wide__fPuKi"};